module.exports = __webpack_public_path__ + "static/img/4.4ff275b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/4.png
// module id = Wlok
// module chunks = 0